import { Product } from '@mews-commander/data-access';
import { lt, useFieldDependency } from '@mews/framework';
import { Optional } from '@mews/std';
import { ProductSelectField } from '../../../../../../../components/form/hookFields';
import { useProductsByServiceId } from '../hooks';
import { ReservationsFilterValues } from '../schema';
import { FilterValueKey } from '../types';

export interface ProductFilterFieldProps {
    products: Optional<Array<Product>>;
}

export const ProductFilterField = ({ products }: ProductFilterFieldProps) => {
    const { dependencyValue: serviceId } = useFieldDependency<ReservationsFilterValues, FilterValueKey.serviceId>({
        dependency: FilterValueKey.serviceId,
        name: FilterValueKey.productIds,
    });

    const { products: filteredProducts } = useProductsByServiceId({ serviceId, products });

    return (
        <ProductSelectField
            compact
            disabled={!serviceId}
            multiselect
            showEmptyValue={false}
            preserveMultiSelectSearch
            name={FilterValueKey.productIds}
            label={lt('Products')}
            products={filteredProducts ?? []}
        />
    );
};
